/**
 * Funkcja sprawdzająca czy numer telefonu jest poprawny.
 * Numer telefonu musi mieć pattern: +48 999-999-999
 * > Najpierw następuje numer kierunkowy - +48, później spacja, 
 *   później trzy sekcje z liczbami z zakresu od 0 do 9 oddzielone znakiem "-"
 * @param phoneNumberToCheck 
 * @returns 
 */
export const isPhoneNumberValid = {
   name: 'isPhoneNumberValid',
   message: 'Nieprawidłowa wartość',
   test: (phoneNumberToCheck: string | undefined) => {

      if(phoneNumberToCheck?.length){
         if(phoneNumberToCheck.startsWith('48', 4)){ // Numer telefonu nie może zaczynać się od "48" (wymóg biznesowy)
            return false
         }
         else {
            const phoneNumberRegexp = /^\+48\s{1,1}([0-9]{3,3}-{1,1})+([0-9]{3,3}-{1,1})+([0-9]{3,3})$/g
   
            return phoneNumberRegexp.test(phoneNumberToCheck)
         }
      }
      else {
         return false
      }
   }
}